// extracted by mini-css-extract-plugin
export var artDirected = "HighlightedSection-module--artDirected--df047";
export var contained = "HighlightedSection-module--contained--5372b";
export var content = "HighlightedSection-module--content--b71f8";
export var heading = "HighlightedSection-module--heading--d3f5c";
export var highlightedsection = "HighlightedSection-module--highlightedsection--89b8f";
export var image = "HighlightedSection-module--image--0e1a8";
export var light = "HighlightedSection-module--light--0dc17";
export var reverse = "HighlightedSection-module--reverse--b393a";
export var text = "HighlightedSection-module--text--6b211";
export var transparent = "HighlightedSection-module--transparent--a116b";
export var vector = "HighlightedSection-module--vector--a7a91";